export function getLocalStorage() {
  try {
    // Get app state from local storage
    const localState = localStorage.getItem("appState");

    // If no prior state stored, return undefined
    if (!localState) return {};

    // Return parsed local state
    return JSON.parse(localState);
  } catch (err) {
    // Ignore read errors; if error then reset state
    return {};
  }
}

export function updateLocalStorage(state) {
  try {
    // Get app state from local storage
    let localState = localStorage.getItem("appState");

    // Prepare loaded state for merging new state into
    if (!localState) localState = {};
    else localState = JSON.parse(localState);

    // merge passed in state with local state
    //    on conflict, save data from passed in state
    localState = Object.assign(localState, state);

    // Store data back into local storage
    localStorage.setItem("appState", JSON.stringify(localState));
  } catch (err) {
    // Ignore write errors
  }
}

export function clearLocalStorage() {
  // Write the empty object into local storage for the app state
  localStorage.setItem("appState", JSON.stringify({}));
}
